(function () {
  angular.module("akitabox.desktop.admin.job.detail", [
    "akitabox.constants",
    "akitabox.core.toast",
    "akitabox.core.services.organization",
    "akitabox.core.services.user",
  ]);
})();
